export const customerTypes = ["Private", "Company"] as const;
export type CustomerType = typeof customerTypes[number];
export type CustomerTypes = CustomerType[];

export abstract class Customer {
  email: string;
  phone: number;
  name: string;
  type: CustomerType;

  constructor(email: string, phone: number, name: string, customerType: CustomerType) {
    this.email = email;
    this.phone = phone;
    this.name = name;
    this.type = customerType;
  }
}
